<script lang="ts" setup>
import { computed, ref } from 'vue';

import type { FormSchema } from '@modules/forms/components/VForm/types';
import type {
  BonusCreateFileFormData,
} from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/types';
import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import VForm from '@modules/forms/components/VForm/VForm.vue';
import { EFormInputTypes } from '@modules/forms/enums';
import { useI18n } from '@modules/i18n/composables';
import { ADMIN_PLAYERS_BONUSES_LIST_ROUTE_NAME } from '@modules/players-bonuses/constants';
import {
  TRANSLATION_PLAYER_BONUS_CREATE_FILE,
} from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/constants';
import {
  useFileCreateBonusMutation,
} from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/mutations';

const { getTranslation } = useI18n();
const imageValue = ref<BonusCreateFileFormData>();

const { mutateAsync: uploadFile, errors, isLoading } = useFileCreateBonusMutation();

const formSchema = computed<FormSchema<BonusCreateFileFormData>>(() => ({
  file: {
    type: EFormInputTypes.SINGLE_FILE,
    label: getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_FILE, 'FILE_HEADER').value,
    dragAndDropLabel: getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_FILE, 'FILE_DESCRIPTION').value,
    value: imageValue.value?.file,
    accept: '.xls, .csv',
    format: 'xls, csv',
  },
}));

async function onSubmit(payload: BonusCreateFileFormData): Promise<void> {
  imageValue.value = payload;
  const formData = new FormData();

  for (const [name, value] of Object.entries(payload)) {
    if (value) {
      formData.append(name, value);
    }
  }

  await uploadFile(formData);
  imageValue.value = undefined;
}
</script>

<template>
  <VForm v-data-qa-auto-id="'FileBonusCreate'"
    :schema="formSchema"
    :submit-btn-label="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_FILE, 'PLAYERS_BONUSES_ADD_BONUS')"
    :custom-errors="errors"
    :is-loading="isLoading"
    @submit="onSubmit"
  >
    <template #secondaryBtn>
      <VBackButton
        :label="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_FILE, 'BACK')"
        :to="{ name: ADMIN_PLAYERS_BONUSES_LIST_ROUTE_NAME }"
      />
    </template>
  </VForm>
</template>
